import { render, staticRenderFns } from "./DeleteAssetsModal.vue?vue&type=template&id=b7496260&scoped=true&"
import script from "./DeleteAssetsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAssetsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAssetsModal.vue?vue&type=style&index=0&id=b7496260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7496260",
  null
  
)

export default component.exports